// React Imports
import React, { Fragment } from 'react';
import Helper from '../../../core/helper/helper';
import RightArrowButton from '../../button/rightArrowButton';
import 'components/card/service/serviceCard.style.scss';
import FeedbackBoxCard from '../../feedback/feedbackBoxCard';
import ServiceNotificationWidgets from './serviceNotificationWidgets';
import CardCorner from './cardCorner';
import CardServiceState from './CardServiceState';

class ServiceFeedbackCard extends React.Component {
  constructor(props) {
    super(props);
    const { data: { item, state, dateEnd, time, timeEnd, dateStart, feedback, valueRating, observations, isAppointment,
      stateAction, stateCheck, stateMessage, showUnreadCheck, showUnreadMessage, allowApprove, showInternalNotes,
      showPaymentAction, isCompact, is_cancelled, missedAppointment, is_confirmed, is_history,
      date_start, date_end, old_date, old_time, schedule, full_day }, data } = this.props;
    this.state = {
      id: data.id,
      item: item,
      titleOrSubtitle: Helper.printValue(item.title || item.subtitle || ''),
      state: state,
      dateEnd: dateEnd,
      time,
      timeEnd,
      dateStart: dateStart,
      feedback: feedback,
      valueRating: valueRating,
      observations: observations,
      isAppointment: isAppointment,
      stateAction,
      stateCheck,
      stateMessage,
      showUnreadCheck,
      showUnreadMessage,
      allowApprove,
      showInternalNotes,
      showPaymentAction,
      isCompact,
      is_cancelled,
      missedAppointment,
      is_confirmed,
      is_history,
      date_start,
      date_end,
      old_date,
      old_time,
      schedule,
      full_day,
      data
    };
    this.randomTitle = Helper.newRandomString(
      Helper.printValue(this.state.titleOrSubtitle)?.length - (Helper.printValue(this.state.titleOrSubtitle)?.slice(" ")[1]?.length)
    );
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      const { item, state, dateEnd, dateStart, feedback, valueRating, observations, isAppointment, id,
        stateAction, stateCheck, stateMessage, showUnreadCheck, showUnreadMessage, allowApprove, showInternalNotes,
        showPaymentAction, isCompact, is_cancelled, missedAppointment, is_confirmed, is_history,
        date_start, date_end, old_date, old_time, schedule, full_day } = this.props.data;
      this.setState({
        id,
        item,
        state,
        dateEnd,
        dateStart,
        feedback,
        valueRating,
        observations,
        isAppointment,
        stateAction,
        stateCheck,
        stateMessage,
        showUnreadCheck,
        showUnreadMessage,
        allowApprove,
        showInternalNotes,
        showPaymentAction,
        isCompact,
        is_cancelled,
        missedAppointment,
        is_confirmed,
        is_history,
        date_start,
        date_end,
        old_date,
        old_time,
        schedule,
        full_day,
        data: this.props.data
      });
    }
  }

  renderValue = (value, random) => {
    const { id } = this.state;

    return (Helper.isLiteVersion() && !id?.includes("int")) ? (
      <Fragment>
        <span>
          {(() => {
            const processedValue = Helper.printValue(value);
            if (processedValue.includes(" ") || processedValue.includes("-")) {
              return processedValue.split(" ")[0].split("-")[0];
            } else {
              return processedValue.slice(0, 2);
            }
          })()}
        </span>
        <span className='pixelized'>{random}</span>
      </Fragment>
    ) : (
      Helper.printValue(value)
    );
  };

  renderItemInformation = () => {
    const { item, titleOrSubtitle, state: { bars }, dateEnd, dateStart, time, timeEnd, isAppointment, full_day } = this.state;
    const iconSrc = (dateEnd && dateEnd !== "Por definir") ? Helper.checkoutIcon(dateEnd, bars, isAppointment) : Helper.checkinIcon(isAppointment, bars, dateStart);
    const dateText = (dateEnd && dateEnd !== "Por definir") ? dateEnd : dateStart;
    const formatedDateText = dateText;
    const formattedTime = full_day ? '' : ' ' + (timeEnd || time || '' ); 

    return (
      <div className='service-equipment-container' onClick={this.props.onClick}>
        <div className='service-equipment-name text-truncate'>{ this.renderValue(titleOrSubtitle, this.randomTitle) }</div>
        <div className='service-equipment-data-row d-flex'>
          <img src={iconSrc} alt=""/>
          <div className='service-date-text'>
            {formatedDateText}
            {formattedTime}
          </div>
        </div>
        {this.renderCardImage(false, item)}
      </div>
    );
  }

  renderCardImage = (isCompact, item) => {
    return isCompact ? null : (
      <div className="card-service-image-container">
        <img
          src={item.image}
          alt="service_image"
          className={Helper.isLiteVersion() ? "pixelized" : ""}
          onError={(e) => (e.target.src = Helper.defaultImage())}
        />
      </div>
    );
  }

  renderCardCorner = (bars, feedback) => {
    const { isAppointment } = this.state;
    return <CardCorner data={{bars, feedback, isAppointment}}/>
  }

  renderCardServiceState = () => {
    const { state, dateStart, old_date, dateEnd, time, timeEnd, old_time, isAppointment, is_cancelled, missedAppointment, is_confirmed, is_history, date_start, date_end, schedule, full_day } = this.state;
    return (
      <CardServiceState
        data={{
          dateStart: date_start,
          old_date: old_date,
          schedule,
          dateEnd: isAppointment ? undefined : date_end,
          time: time,
          timeEnd,
          old_time: old_time,
          state,
          dateStartState: dateStart,
          dateEndState: dateEnd,
          isAppointment: isAppointment,
          is_confirmed: is_confirmed,
          is_history: is_history,
          is_cancelled: is_cancelled,
          missedAppointment: missedAppointment,
          full_day: full_day,
        }}
        isSmall={true}
      />
    );
  }

  render() {
    const { data: { feedback, valueRating, observation, id }} = this.props;
    const { state, item, isCompact, stateAction, stateCheck, stateMessage, showUnreadCheck, showUnreadMessage, allowApprove, showInternalNotes, showPaymentAction } = this.state;
    return (
      <div className="card-service-main-container p-3">
        <ServiceNotificationWidgets
            data={{stateAction, stateCheck, stateMessage, showUnreadCheck, showUnreadMessage, showInternalNotes, allowApprove, isCompact, showPaymentAction}}
            goToDetails={this.props.onClick}/>  
        {this.renderCardCorner(state.bars, feedback)}
        {this.renderItemInformation()}
        {this.renderCardServiceState()}

        <div className="mt-2 pt-1">
          <FeedbackBoxCard
            data={{ feedback, valueRating, observation, id }}
            type="small"
            callback={this.props.callback}
          />
        </div>

        <div className="d-none d-md-block">
          <RightArrowButton black={true} onClick={this.props.onClick} />
        </div>
      </div>
    );
  }
}

export default ServiceFeedbackCard;
